import {
  CALL_TO_ACTIONS_FETCH_REQUEST,
  CALL_TO_ACTIONS_FETCH_SUCCESS,
  CALL_TO_ACTIONS_FETCH_FAIL,
} from '../actions/call_to_actions'
import { Map as ImmutableMap, List as ImmutableList, fromJS } from 'immutable'

const initialState = ImmutableMap({
  items: ImmutableList(),
  lastFetchedAt: null,
  isLoading: false,
  isFetched: false,
  isError: false,
})

const normalizeCallToAction = (cta) => {
  return {
    id: cta.id,
    title: cta.title,
    content: cta.content,
    primaryBtnTitle: cta.primaryBtnTitle,
    primaryBtnAction: cta.primaryBtnAction,
    secondaryBtnTitle: cta.secondaryBtnTitle,
    secondaryBtnAction: cta.secondaryBtnAction,
  }
}

const normalizeCallToActions = (ctas) => {
  return fromJS(ctas.map((cta) => {
    return normalizeCallToAction(cta)
  }))
}

export default function callToActionsReducer(state = initialState, action) {
  switch(action.type) {
    case CALL_TO_ACTIONS_FETCH_REQUEST:
      return state.withMutations((map) => {
        map.set('isLoading', true)
        map.set('isFetched', false)
        map.set('isError', false)
      })
    case CALL_TO_ACTIONS_FETCH_SUCCESS:
      return state.withMutations((map) => {
        map.set('items', normalizeCallToActions(action.ctas))
        map.set('isLoading', false)
        map.set('isFetched', true)
        map.set('isError', false)
        map.set('lastFetchedAt', new Date())
      })
    case CALL_TO_ACTIONS_FETCH_FAIL:
      return state.withMutations((map) => {
        map.set('isLoading', false)
        map.set('isFetched', true)
        map.set('isError', true)
      })
    default:
      return state
  }
}

